module.exports = __webpack_public_path__ + "static/media/tietosuojaseloste.433b2186.pdf";